import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PartsPanel from './PartsPanel';
import NoteWithStamp from './NoteWithStamp';
import {
  partsForAppraisal, partsTotals, tabWorkItemPartsEnabled, tabPartFilesEnabled,
} from './partsUtils';
import { sendEstimate } from '../../actions/apiEstimates';

const AppraisalPartsSection = ({
  appraisalId, vehicleId, tab, appraisal,
}) => {
  const dispatch = useDispatch();
  const active_vehicle = useSelector(state => state.settings_refresh?.active_vehicle || {});
  const all_tabs = useSelector(state => state.settings_site?.all_tabs || []);
  const currentUser = useSelector(state => state.current_user || {});
  const currentUserProfile = useSelector(state => state.settings_users?.current_user_profile || {});
  const uid = parseInt(currentUser.user, 10) || currentUserProfile?.id || null;

  const enabled = useMemo(() => tabWorkItemPartsEnabled(all_tabs, tab), [all_tabs, tab]);
  const showFiles = useMemo(() => tabPartFilesEnabled(all_tabs, tab), [all_tabs, tab]);
  const parts = useMemo(
    () => partsForAppraisal(active_vehicle, appraisalId),
    [active_vehicle, appraisalId],
  );

  const approvedTotal = useMemo(() => partsTotals(parts).approvedTotal, [parts]);
  const laborTotal = Number(appraisal?.labor_units?.[0] || 0) * Number(appraisal?.labor_price?.[0] || 0);
  const currentPartsPrice = Number(appraisal?.parts_price?.[0] || 0);
  const savedNote = appraisal?.parts_note?.[0] || '';
  const locked = ['approved', 'completed'].includes(appraisal?.ro_status?.[0]);
  const [note, setNote] = useState(savedNote);

  useEffect(() => {
    if (!enabled || parts.length === 0) return;
    if (Math.abs(currentPartsPrice - approvedTotal) < 0.005) return;
    const parts_price = Number(approvedTotal.toFixed(2));
    const estimate_total = Number((approvedTotal + laborTotal).toFixed(2));
    dispatch(sendEstimate(appraisalId, {
      vehicle_id: vehicleId,
      parts_price,
      estimate_total,
      estimate: estimate_total,
    }, 'addEstimateError'));
  }, [enabled, approvedTotal, parts.length, currentPartsPrice, laborTotal]);

  const saveNote = () => {
    if ((note || '') === (savedNote || '')) return;
    dispatch(sendEstimate(appraisalId, {
      vehicle_id: vehicleId,
      parts_note: note,
      parts_note_by_uid: uid,
      parts_note_by_date: new Date().toISOString(),
    }, 'addEstimateError'));
  };

  if (!enabled || !appraisalId || !vehicleId) return null;

  return (
    <PartsPanel
      vehicleId={vehicleId}
      parts={parts}
      scope="appraisals"
      appraisalId={appraisalId}
      title="Parts"
      showFiles={showFiles}
      locked={locked}
    >
      <NoteWithStamp
        value={note}
        onChange={e => setNote(e.target.value)}
        onBlur={saveNote}
        byUid={appraisal?.parts_note_by_uid?.[0]}
        byDate={appraisal?.parts_note_by_date?.[0]}
      />
    </PartsPanel>
  );
};

export default AppraisalPartsSection;
